/**
 * Time words for the Live work panel — always India time (Asia/Kolkata), never the browser's zone,
 * never an ISO string on screen. "25 min ago", "4:52 pm", "18 Oct".
 */
const PARTS = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'Asia/Kolkata',
  year: 'numeric',
  month: 'short',
  day: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
  hourCycle: 'h23',
});

function parts(iso: string) {
  const out: Record<string, string> = {};
  for (const p of PARTS.formatToParts(new Date(iso))) out[p.type] = p.value;
  return out;
}

const valid = (iso: string | null | undefined): iso is string => !!iso && !Number.isNaN(Date.parse(iso));

/** "4:52 pm" in IST. */
export function clockText(iso: string | null | undefined): string {
  if (!valid(iso)) return '';
  const p = parts(iso);
  const h = Number(p.hour);
  return `${h % 12 === 0 ? 12 : h % 12}:${p.minute} ${h < 12 ? 'am' : 'pm'}`;
}

/** "18 Oct" in IST. */
export function dayText(iso: string | null | undefined): string {
  if (!valid(iso)) return '';
  const p = parts(iso);
  return `${Number(p.day)} ${p.month}`;
}

/** "just now" · "25 min ago" · "3 h ago" · "18 Oct". */
export function agoText(iso: string | null | undefined, now: Date = new Date()): string {
  if (!valid(iso)) return '';
  const min = Math.floor((now.getTime() - Date.parse(iso)) / 60000);
  if (min < 1) return 'just now';
  if (min < 60) return `${min} min ago`;
  if (min < 24 * 60) return `${Math.floor(min / 60)} h ago`;
  return dayText(iso);
}
